import { NavLink, Outlet, useNavigate } from "react-router-dom"
import { setupLinks } from "../../entries"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { BreadCrumbsGeneral } from "../../components/NavigationComponents"
import { PermissionContext } from "../../contexts/PermissionContexts"


export const SetupPage = () => {
    const { t } = useTranslation('settings')
    return (
        <div className="flex flex-col justify-start items-center w-full py-2 gap-5 pb-10 px-4 h-full">
            <div className="w-full">
                <h1 className="text-xl font-semibold">{t('Setup')}</h1>
                <SidebarLayout links={setupLinks} />
            </div>

        </div>
    )
}


const SidebarLayout = ({ links }) => {
    const { t } = useTranslation('settings')

    const { permissions, hasPermission } = useContext(PermissionContext)
    const [breadCrumbs, setBreadCrumbs] = useState(
        [
            {
                link: "/admin/dashboard",
                name: t("Home")
            },
            {
                link: "/admin/setup/quick-replies",
                name: t("Setup")
            },
            {
                link: null,
                name: t('Quick Replies')
            }
        ]
    )
    const navigator = useNavigate()

    // Open the first page the user may see (not always Quick Replies); waits for the permissions to load.
    useEffect(() => {
        if (window.location.pathname.replace(/\/$/, "") == "/admin/setup") {
            const first = links.find((link) => hasPermission(link.permission))
            if (first) {
                getTitle(t(first.title))
                navigator(`/admin/setup/${first.link}`)
            }
        }
    }, [permissions])

    const getTitle = (title) => {
        setBreadCrumbs((prev) => {
            prev.pop()
            return [...prev, {
                link: null,
                name: title
            }]
        })
    }

    return (
        <>
            <BreadCrumbsGeneral elements={breadCrumbs} />
            <div className="flex flex-col md:flex-row w-full py-3 gap-3">
                {/* Options Navigation */}
                <div className="w-full md:w-80 grid grid-cols-2 sm:grid-cols-4 gap-2 md:gap-0 md:flex md:flex-col md:join join-vertical shadow-md h-fit">
                    {
                        links.map((link, index) =>
                            hasPermission(link.permission) &&
                            <NavigationLink key={index} props={link} getTitle={getTitle} />
                        )
                    }
                </div>
                {/* Options View Page */}
                <div className="flex  flex-col w-full md:px-2 h-full">
                    <Outlet />
                </div>
            </div>
        </>
    )
}



export const NavigationLink = ({ props, getTitle }) => {
    const { t } = useTranslation('settings')
    return (
        <NavLink className="join-item btn border-none bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600"
            to={props.link}
            onClick={() => getTitle(t(props.title))}
            style={({ isActive }) => {
                return {
                    background: isActive
                        ? "#145388"
                        : "",
                    color: isActive ? "rgb(250 250 250)" : "",
                };
            }}
        >
            <span>{t(props.title)}</span>
        </NavLink>
    )
}